import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SET_STATE,
  LOGIN_USER_GOOGLE
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  id: '',
  name: '',
  surname: '',
  role: '',
  userType: '',
  email: '',
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_USER_GOOGLE:
      state = {
        ...state,
        loading: true,
      }
      break
    case SET_STATE:
      state = {
        ...state,
        ...action.payload,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        id:action.payload.user.id,
        name: action.payload.user.name,
        surname: action.payload.user.surname,
        role: action.payload.user.role,
        email: action.payload.user.email,
        userType: action.payload.user.userType,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
